import React from "react";
import { useTranslation } from "react-i18next";
import "./priorityProtection.scss";

function DataProtection() {

  const { t } = useTranslation()

  return (
    <div className="container-numerous-processes">
      <div className="texts-numerous-processes">
        <h1>{t("database.data_protection.title")}</h1>
        <p>{t("database.data_protection.section_text_1")}</p>
        <p>{t("database.data_protection.section_text_2")}</p>
      </div>
    </div>
  );
}

export default DataProtection;
